import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, Redirect } from "react-router-dom";
import RegisterPassword from "./register-password";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import App from "../../App";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";

//register component for register, data is stored in state along with error message
class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      password: null,
      doneFirstPart: false,
      redirect: false,
      errorMessage: null,
      nameErrorMessage: "",
      emailErrorMessage: "",
      phoneErrorMessage: "",
    };
    this.source = axios.CancelToken.source();
  }

  toastMessagePopUp = (message) => {
    // function to display toast popup error message
    toast.error(message, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  // function to validate phone number
  validatePhonenumber = (inputnumber) => {
    const phoneno = /^\d{10}$/;
    return phoneno.test(inputnumber);
  };

  // function to validate email
  ValidateEmail = (mail) => {
    let atPosition = mail.indexOf("@");
    let dotPosition = mail.lastIndexOf(".");
    return !(
      atPosition < 1 ||
      dotPosition < atPosition + 2 ||
      dotPosition + 2 >= mail.length
    );
  };

  //call back function passed as props to register-password.js goback ( <- Button ) button
  goBack = () => {
    this.setState({
      doneFirstPart: false,
    });
  };

  //call back function passed as props to register-password.js register button, it recieves password and does a axios call along with the data from the state to register a visitor
  setPassword = (variable) => {
    this.setState({ loading: true });
    this.setState({ password: variable }, () => {
      let data = {};
      data.email = this.state.email;
      data.password = this.state.password;
      data.firstname = this.state.firstName;
      data.phone_number = this.state.phone;
      data.cPassword = this.state.password;
      data.lastname = this.state.lastName;
      axios
        .post(App.baseUrl + "sign-up", data, {
          cancelToken: this.source.token,
        })
        .then(() => {
          toast.success("Registered successfully", {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          this.setState({ loading: false, redirect: true });
        })
        .catch((error) => {
          if (error.response) {
            this.toastMessagePopUp(error.response.data.message);
            this.setState({ errorMessage: error.response.data.message });
          } else {
            this.toastMessagePopUp(
              "Something went wrong, please check your Internet connection or refresh the page"
            );
          }
          this.setState({ loading: false });
        });
    });
  };

  //handleinput change function to handle all the input data and continue button
  handleInputChange = (event) => {
    let value = null;
    //set value
    if (event.target.id === "form-ctrl-firstname") {
      this.setState({ firstName: event.target.value });
    }
    if (event.target.id === "form-ctrl-lastname") {
      this.setState({ lastName: event.target.value });
    }
    if (event.target.id === "form-ctrl-email") {
      this.setState({ email: event.target.value });
    }
    if (event.target.id === "form-ctrl-phone") {
      value = event.target.value;
      let k;
      k = parseInt(value);
      this.setState({ phone: k });
    }
    // check for errors from here
    if (event.target.id === "buttonedit") {
      if (!this.ValidateEmail(this.state.email)) {
        this.setState({ emailErrorMessage: "Enter valid email" });
      } else {
        this.setState({ emailErrorMessage: "" });
      }
      if (!this.validatePhonenumber(this.state.phone)) {
        this.setState({ phoneErrorMessage: "Enter valid phone number" });
      } else {
        this.setState({ phoneErrorMessage: "" });
      }
    }
    // if we press the continue button
    if (
      event.target.id === "buttonedit" &&
      this.state.EmailId !== "" &&
      this.state.firstName !== "" &&
      this.state.lastName !== "" &&
      this.ValidateEmail(this.state.email) &&
      this.state.email !== null &&
      this.state.firstName !== null &&
      this.state.lastName !== null &&
      this.validatePhonenumber(this.state.phone) &&
      typeof this.state.phone === "number"
    ) {
      this.setState({
        doneFirstPart: true,
      });
    }
  };

  componentWillUnmount() {
    this.source.cancel();
  }

  render() {
    const { doneFirstPart, firstName, lastName, phone, email } = this.state;
    let defaultRegisterComponent = (
      <div className="background-image">
        <div className="line-color-background">
          <span className="register-login">REGISTER</span>
        </div>
        <Container fluid>
          <Row>
            <Col xs={1} />
            <Col xs={10}>
              <div className="login-text-details">TO GUIDE APP</div>
              <Form>
                <Form.Group>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    name="firstName"
                    onChange={this.handleInputChange}
                    id="form-ctrl-firstname"
                    type="text"
                    value={this.state.firstName}
                    placeholder="Enter your first name"
                  />
                  <Form.Control
                    name="lastName"
                    onChange={this.handleInputChange}
                    id="form-ctrl-lastname"
                    type="text"
                    value={this.state.lastName}
                    placeholder="Enter your last name"
                  />
                </Form.Group>
                <p className="show-alert" id="name-validation-error">
                  {this.state.nameErrorMessage}
                </p>
                <Form.Group>
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    name="email"
                    onChange={this.handleInputChange}
                    id="form-ctrl-email"
                    type="email"
                    value={this.state.email}
                    placeholder="Enter email address"
                  />
                </Form.Group>
                <p className="show-alert" id="email-validation-error">
                  {this.state.emailErrorMessage}
                </p>
                <Form.Group>
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    name="phone"
                    onChange={this.handleInputChange}
                    id="form-ctrl-phone"
                    type="number"
                    pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                    placeholder="Enter phone number"
                    value={this.state.phone}
                  />
                </Form.Group>
                <p className="show-alert" id="phone-validation-error">
                  {this.state.phoneErrorMessage}
                </p>
                <div>
                  <Link id="login-register-link" to="/login">
                    Have an account already ?
                  </Link>
                  <Button
                    id="buttonedit"
                    onClick={this.handleInputChange}
                    disabled={!email || !phone || !lastName || !firstName}
                  >
                    Continue
                  </Button>
                </div>
              </Form>
            </Col>
            <Col xs={1} />
          </Row>
        </Container>
      </div>
    );
    // checks if we have pressed continue button or not from this.state.doneFirstPart
    let registerpasswordComponent = this.state.doneFirstPart ? (
      <RegisterPassword
        gobackmethod={this.goBack}
        setpasswordmethod={this.setPassword}
        error={this.state.errorMessage}
      />
    ) : (
        defaultRegisterComponent
      );
    return (
      <div>
        {/* if user exits then redirect them to /login */}
        {this.state.loading ? (
          <Spinner animation="border" id="spinner-loading-show" />
        ) : this.state.redirect ? (
          <Redirect to="/login" />
        ) : null}
        {!this.state.loading ? registerpasswordComponent : null}
        <ToastContainer
          limit={1}
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    );
  }
}

export default Register;
